module.exports = __webpack_public_path__ + "img/tractor-photo-02.a1747364.jpeg";